import React, { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import DealerListPrice from '../DealerListPrice';
import StickyNavBar from '../StickyNavbar';
import { vehicleContext } from '../VehicleProvider';
import { Wrapper, BackgroundColorWrap } from './ContentWrapper.styles';
import { IS_T3_WEBSITE } from '../../constants/environment';
import 'react-loading-skeleton/dist/skeleton.css';

const ContentWrapper: React.FC = () => {
  const { vehicle, loading } = useContext(vehicleContext);

  if (!vehicle && !loading) return null;

  return (
    <>
      <BackgroundColorWrap>
        <Wrapper>{loading ? <Skeleton /> : <DealerListPrice />}</Wrapper>
      </BackgroundColorWrap>
      {!IS_T3_WEBSITE && <StickyNavBar />}
    </>
  );
};

export default ContentWrapper;
